module.exports = __webpack_public_path__ + "static/dashboard_en_bg@3x-5c4641f39cd696c17ff2078ef340cbf2.png";